<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent" v-if="!loadingLang">
        <div class="success" v-if="success">
          <div class="successCnt">
            <img src="../assets/sent.png">
            <h4>{{lang.langs.feedback_success.value}}</h4>
            <p>{{lang.langs.feedback_success_desc.value}}</p>
            <button class="secondary" v-on:click="close(true)">Tutup</button>
          </div>
        </div>
        <h4>{{lang.langs.feedback_title.value}}</h4>
        <p>{{lang.langs.feedback_desc.value}}</p>
        <div class="formCnt">
          <form v-on:submit.prevent="handleSubmit">
            <div class="fieldGroup">
              <label>Jenis Masukan</label>
              <select class="field" v-model="form.type.model">
                <option value="feedback">
                  <template v-if="lang && lang.code === 'id'">
                    Kritik dan Saran
                  </template>
                  <template v-else>
                    Suggestions & Feedback
                  </template>
                </option>
                <option value="upload">
                  <template v-if="lang && lang.code === 'id'">
                    Unggahan Perkara
                  </template>
                  <template v-else>
                    Case Upload
                  </template>
                </option>
              </select>
            </div>
            <div :class="{fieldGroup: true, hasError: form.name.error}">
              <label>{{lang.langs.feedback_name.value}}*</label>
              <input type="text" class="field"
                :placeholder="lang.langs.feedback_name_placeholder.value"
                v-model="form.name.model" v-on:input="fieldChanged('name')">
              <div class="fieldError" v-if="form.name.error">
                {{lang.langs.feedback_name_error.value}}</div>
            </div>
            <div :class="{fieldGroup: true, hasError: form.email.error}">
              <label>{{lang.langs.feedback_email.value}}*</label>
              <input type="text" class="field"
                :placeholder="lang.langs.feedback_email_placeholder.value"
                v-model="form.email.model" v-on:input="fieldChanged('email')">
              <div class="fieldError" v-if="form.email.error">
                {{form.email.error}}</div>
            </div>
            <div class="fieldGroup" :class="{hasError: form.organization.error}">
              <label v-if="lang && lang.code === 'id'">Instansi*</label>
              <label v-else>Organization*</label>
              <input type="text" class="field" v-model="form.organization.model"
                v-on:input="form.organization.error = null"
                :placeholder="lang && lang.code === 'id' ? 'Nama instansi...' : 'Organization name...'">
              <div class="fieldError" v-if="form.organization.error">
                {{form.organization.error}}
              </div>
            </div>
            <div class="fieldGroup">
              <label v-if="lang && lang.code === 'id'">Subjek</label>
              <label v-else>Subject</label>
              <input type="text" class="field" v-model="form.subject.model"
                :placeholder="lang && lang.code === 'id' ? 'Tulis subjek disini...' : 'Write subject here...'">
            </div>
            <div :class="{fieldGroup: true, hasError: form.feedback.error}"
              v-if="form.type.model === 'feedback'">
              <label>{{lang.langs.feedback_content.value}}</label>
              <textarea
                :placeholder="lang.langs.feedback_content_placeholder.value"
                class="field" rows="5" v-model="form.feedback.model"
                v-on:input="fieldChanged('feedback')"/>
              <div class="fieldError" v-if="form.feedback.error">
                {{lang.langs.feedback_content_error.value}}</div>
            </div>
            <div class="fieldGroup" v-if="form.type.model === 'upload'">
              <label v-if="lang && lang.code === 'id'">Unggahan perkara</label>
              <label v-else>Case Upload</label>
              <textarea
                :placeholder="lang && lang.code === 'id' ? 'Unggahan perkara...' : 'Case upload...'"
                class="field" rows="5" v-model="form.unggahanPerkara.model"/>
            </div>
            <div class="fieldGroup">
              <label v-if="lang && lang.code === 'id'">Catatan</label>
              <label v-else>Notes</label>
              <textarea
                :placeholder="lang && lang.code === 'id' ? 'Tulis catatan...' : 'Write notes...'"
                class="field" rows="5" v-model="form.notes.model"/>
            </div>
            <div class="fieldGroup" v-if="form.type.model === 'upload'">
              <label v-if="lang && lang.code === 'id'">Attachment File (PDF atau MS WORD)</label>
              <label v-else>File Lampiran</label>
              <input type="file" class="field" v-on:change="fileChanged" ref="file"
                accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/pdf">
            </div>
          </form>
        </div>
        <div class="modalAction">
          <button class="secondary" type="button"
            v-on:click="close(false)">{{lang.langs.cancel_button.value}}</button>
          <button type="submit"
            :class="{btnLoading: loading}"
            v-on:click="handleSubmit">
            <span class="lg">{{lang.langs.feedback_button.value}}</span>
            <span class="sm">Submit</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'feedback',
  components: {},
  data() {
    return {
      show: false,
      next: null,
      loading: false,
      success: false,
      form: {
        name: { model: '', error: null },
        email: { model: '', error: null },
        feedback: { model: '', error: null },
        type: { model: 'upload' },
        organization: { model: '', error: null },
        subject: { model: '', error: null },
        unggahanPerkara: { model: '', error: null },
        notes: { model: '', error: null },
      },
      file: null,

      /**
       * Language
       *
       */
      loadingLang: true,
      lang: null,
    };
  },
  methods: {
    open(d, n) {
      document.getElementsByTagName('BODY')[0].classList.add('no-scroll');
      this.loading = false;
      this.success = false;
      this.form.name.model = '';
      this.form.name.error = null;
      this.form.email.model = '';
      this.form.email.error = null;
      this.form.feedback.model = '';
      this.form.feedback.error = null;

      this.form.type.model = 'upload';
      this.form.type.error = null;
      this.form.organization.model = '';
      this.form.organization.error = null;
      this.form.subject.model = '';
      this.form.subject.error = null;
      this.form.unggahanPerkara.model = '';
      this.form.unggahanPerkara.error = null;
      this.form.notes.model = '';
      this.form.notes.error = null;
      this.file = null;

      this.next = n;
      this.show = true;
    },
    close(b, d) {
      document.getElementsByTagName('BODY')[0].classList.remove('no-scroll');
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    fileChanged() {
      [this.file] = this.$refs.file.files;
    },
    handleSubmit() {
      const formData = {
        name: this.form.name.model,
        email: this.form.email.model,
        feedback: this.form.feedback.model,
        type: this.form.type.model,
        organization: this.form.organization.model,
        subject: this.form.subject.model,
        unggahanPerkara: this.form.unggahanPerkara.model,
        notes: this.form.notes.model,
      };
      if (!formData.name || formData.name === '') {
        this.form.name.error = (this.lang && this.lang.code === 'id')
          ? 'Mohon isi nama Anda' : 'Please input your name';
        return;
      }
      if (!formData.email || formData.email === '') {
        this.form.email.error = (this.lang && this.lang.code === 'id')
          ? 'Mohon isi alamat email' : 'Please input your email address';
        return;
      }
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (!formData.email.match(emailRegex)) {
        this.form.email.error = (this.lang && this.lang.code === 'id')
          ? 'Alamat email tidak valid' : 'Email address is not valid';
        return;
      }
      if (!formData.organization || formData.organization === '') {
        this.form.organization.error = (this.lang && this.lang.code === 'id')
          ? 'Mohon isi nama instansi' : 'Please input your organization name';
        return;
      }
      this.loading = true;
      this.$http.post(this.$config.uri('misc/feedback'), formData).then((r) => {
        if (formData.type === 'upload' && this.file) {
          /**
           * Upload file
           *
           */
          const formDataFile = new FormData();
          formDataFile.append('file', this.file);
          this.$http.post(this.$config.uri(`misc/feedback/${r.data.data.id}/upload`), formDataFile, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then((r2) => {
            this.loading = false;
            this.success = true;
          });
        } else {
          this.loading = false;
          this.success = true;
        }
      });
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
  },
  mounted() {
    let lang = localStorage.getItem('portal_putusan_penting_icel_lang');
    if (!lang) lang = window.navigator.userLanguage || window.navigator.language;
    if (lang === 'en-US' || lang === 'en') lang = 'en';
    else if (lang === 'id-ID' || lang === 'id') lang = 'id';
    else lang = 'id';
    this.$http.get(this.$config.uri(`misc/lang/${lang}`)).then((rlang) => {
      this.loadingLang = false;
      this.lang = rlang.data.data;
    });
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      max-width: none;
      width: 480px;
      text-align: left;

      box-sizing: border-box;
      width: auto;
      left: 0; top: 0; right: 0; bottom: 0;
      border-radius: 0;
      margin: 0;
      padding: 10px 80px;
      @media (max-width: 680px) {
        // width: auto;
        // left: 10px; right: 10px;
        padding: 10px 26px;
      }
      .success{
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;
        background-color: #fff;
        z-index: 991;
        text-align: center;
      }
      .formCnt{
        overflow: auto;
        // max-height: 54vh;
        box-sizing: border-box;
        margin: 0 -80px -30px;
        padding: 16px 80px 30px;
        border-top: #eee 1px solid;
        height: calc(100vh - 180px);
        form{
          max-width: 560px;
          margin: 0 auto;
        }
      }
      h4{
        padding-top: 20px;
        margin: 0 0 4px;
        font-size: 24px;
        font-weight: normal;
        color: #444;

        // margin-left: -40px;
        text-align: center;
        @media (max-width: 680px) {
          // margin-left: 0;
        }
      }
      p{
        margin: 0 0 16px;
        color: #767676;

        // margin-left: -40px;
        text-align: center;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        @media (max-width: 680px) {
          // margin-left: 0;
        }
        @media (max-width: 680px) {
          font-size: 15px;
        }
      }
      .modalAction{
        margin: 30px -80px -30px;
        padding: 12px 30px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        position: relative;
        @media (max-width: 680px) {
          margin: 30px -26px -20px;
          padding: 12px 26px;
        }
        button {
          margin-left: 10px;
          span{
            &.sm{
              display: none;
            }
            @media (max-width: 768px) {
              display: none;
              &.sm{
                display: block;
              }
            }
            b{
              font-weight: 300;
              @media (max-width: 680px) {
                display: none;
              }
            }
          }
        }
      }
    }
  }
</style>
